  (function() {
    // CONFIG
    var triggerParam = 'lor15ml';
    var variantId = '45471643664704'; // Variant to add
    var quantity = 1;

    function hasTriggerParam() {
      var url = new URL(window.location.href);
      // Matches either ?lor15ml or &lor15ml, with or without value
      if (url.searchParams.has(triggerParam)) return true;
      // Also handle raw query like ?lor15ml with no equals sign (older themes/links)
      return (url.search || '').replace(/^\?/, '').split('&').some(function(p) { return p === triggerParam; });
    }

    function alreadyProcessed() {
      return sessionStorage.getItem('autoAdd_' + triggerParam) === '1';
    }

    function markProcessed() {
      sessionStorage.setItem('autoAdd_' + triggerParam, '1');
    }

    function addToCart() {
      // Prevent duplicate adds on reloads or multi-page navigations
      if (alreadyProcessed()) return;

      // Shopify AJAX cart endpoint
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function(data) {
        // Mark so we don't add again in this session
        markProcessed();

        // Optional: show a lightweight confirmation (non-intrusive)
        console.log('Variant added to cart:', data);
        // Optionally redirect to cart or open drawer:
        // window.location.href = '/cart';
        // Or dispatch event your cart drawer listens to
        // document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function(err) {
        console.error(err);
      });
    }

    if (hasTriggerParam()) {
      // Run after page is interactive
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addToCart);
      } else {
        addToCart();
      }
    }
  })();